import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  location: Yup.string()
    .required('Location Name is required')
    .max(100, 'Location Name is too long - should be 100 chars maximum'),
  address: Yup.string().required('Address is required'),
  postalCode: Yup.object()
    .shape({
      value: Yup.string().required('Post Code is required'),
      label: Yup.string().required('Post Code is required'),
    })
    .required('Post Code is required'),
  city: Yup.string().required('Town is required'),
  county: Yup.string().required('County is required'),
});

export default validationSchema;
